module.exports = __webpack_public_path__ + "img/7.d3455207.png";